<template>
  <v-container id="analiticos-ca-historico" tag="section">
    <v-row>
      <v-col cols="12">
        <analiticos-ca-data-table :items="items" :loadingItems="loadingItems" @rechargeTable="getAnaliticosCA()" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import AnaliticoCaService from '@/services/AnaliticoCaService';
  import dayjs from 'dayjs';
  import tourMixins from '@/mixins/tourMixins';
  import pusherMixins from '@/mixins/pusherMixins';

  export default {
    components: {
      AnaliticosCaDataTable: () => import('@/components/saneamentoVoc/analiticosCa/AnaliticosCaDataTable.vue')
    },
    mixins: [pusherMixins, tourMixins],

    data() {
      return {
        items: [],
        loadingItems: false,
        arrTour: [
          {
            element: '#btn-novo-calculo',
            intro: 'Clicando neste botão você poderá criar novos Analíticos de CA.',
            scrollTo: 'tooltip',
            position: 'right'
          },
          {
            element: '#analitico-ca-historico-search',
            intro: 'Neste campo você poderá pesquisar por Analíticos de CA já existentes.',
            scrollTo: 'tooltip',
            position: 'bottom'
          },
          {
            element: '#action-download-analitico-ca',
            intro: 'Clicando neste ícone você poderá fazer o download em .XLSX do resultado do seu Analítico de CA.',
            scrollTo: 'tooltip',
            position: 'left'
          },
          {
            element: '#action-more-analitico-ca',
            intro: 'Aqui você acessa as demais opções para seu Analítico de CA, executá-lo novamente ou deletá-lo.',
            scrollTo: 'tooltip',
            position: 'left'
          }
        ]
      };
    },

    mounted() {
      this.getAnaliticosCA();
      this.subscribe();
    },

    methods: {
      subscribe() {
        this.pusherChannel.bind('refreshAnaliticosCA', () => {
          this.getAnaliticosCA();
        });
      },
      getAnaliticosCA() {
        this.loadingItems = true;

        AnaliticoCaService.getAnaliticosCA(this.$route.params.id)
          .then((response) => {
            this.items = [];

            response.data.items.forEach((element) => {
              this.items.push({
                id: element.id,
                usuario: element.usuario.nome,
                usuario_id: element.usuario.id,
                status: element.status,
                executed: element.data_processamento ? dayjs(element.data_processamento).format('DD/MM/YYYY HH:mm') : '-',
                filtros: JSON.parse(element.filtros),
                numFiltros: element.num_filtros
              });
            });
          })
          .catch((err) => {
            this.$toast.error('Erro ao recuperar Analíticos de CA.', '', { position: 'topRight' });
            console.error(err);
          })
          .finally(() => {
            ((this.loadingItems = false), this.iniciarTourPagina());
          });
      },

      iniciarTourPagina() {
        if (this.tourFuncCalled) return;

        let arrTourFormatted = this.items.length ? this.arrTour : this.arrTour.splice(0, 2);
        this.iniciarTour(arrTourFormatted);
      }
    }
  };
</script>

<style>

</style>
